// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + "styles" + "." + "59ecde64c62ed16c1595" + ".css";
};